import { createFileRoute } from '@tanstack/react-router'

import CreateGapoktanPage from '@/components/pages/backoffice/_klb-petani/_gapoktan/_create/containers/CreateGapoktanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/gapoktan/create/'
)({
  component: CreateGapoktanPage
})
